<template>
  <div class="toast-notification" :class="`toast-notification--${type}`">
    <div class="toast-title">
      <icon-check-fill v-if="type === 'success'" />
      <icon-cross-fill v-if="type === 'error'" />
      {{ title }}
    </div>
    <button
      v-if="ctaText !== ''"
      type="button"
      class="toast-cta"
      @click="handleClick"
    >
      {{ ctaText }}
    </button>
  </div>
</template>

<script>
/**
 * Vue: Toast Notification
 * -----------------------------------------------------------------------------
 * Single toast notification for toast overlay.
 */
import { mapActions } from 'pinia';
import useToastNotificationsStore from '~stores/toast-notifications';

import IconCheckFill from '~icons/general/check-fill.svg';
import IconCrossFill from '~icons/general/cross-fill.svg';

export default {
  name: 'ToastNotification',

  components: {
    IconCheckFill,
    IconCrossFill,
  },

  props: {
    title: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    ctaText: {
      default: '',
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    ctaCallback: {
      required: false,
      type: Function,
      default: () => {
        return null;
      },
    },
  },

  created() {
    setTimeout(() => {
      this.dismissToast();
    }, 3000);
  },

  methods: {
    /**
     * Map Pinia actions.
     */
    ...mapActions(useToastNotificationsStore, ['clearToast']),

    handleClick() {
      this.ctaCallback();
      this.dismissToast();
    },

    dismissToast() {
      this.clearToast(this.id);
    },
  },
};
</script>
